/* eslint-disable */
import styles from './index.module.scss'
import Useful from '../../components/pages/useful'
import translate from '../../utils/translate.json'
import { PageContext } from '../../context/PageContextProvider'
import { useState, useContext, useEffect, useMemo } from 'react'
import { Calculator, LangArrows, Info } from '../../icons'
import { GeneralInput } from '../../components/core/input'
import { FormButton } from '../../components/core/button'
import StepLine from '../../components/core/stepLine'
import {
  calculateVacationDaysBetween,
  calculateEndDateFromPaidDays,
  getEligibleFullMonths,
  calculateVacation2026,
} from './vacationCalculator2026'

const Calculator2 = ({ className }) => {
  const { language } = useContext(PageContext)

  // 1. Tarixlər
  const [hireDate, setHireDate] = useState('')
  const [vacationStart, setVacationStart] = useState('2026-07-01')
  const [vacationEnd, setVacationEnd] = useState('2026-07-21')
  const [vacationDays, setVacationDays] = useState(21)

  // Bayram günləri və aralıq statistikası
  const [holidayInfo, setHolidayInfo] = useState(null)

  // 2. Qanunvericilik Zəmanəti & Vəzifə maaşı
  const [currentGrossSalary, setCurrentGrossSalary] = useState('1000')

  // 3. Məzuniyyət ayında işlənmiş günlər üçün maaş
  const [currentMonthWorkedPay, setCurrentMonthWorkedPay] = useState('0')

  // 4. Dinamik tam aylar və qazanclar
  const eligibleMonths = useMemo(() => {
    return getEligibleFullMonths(hireDate, vacationStart)
  }, [hireDate, vacationStart])

  const [monthlySalaries, setMonthlySalaries] = useState({})

  // Dinamik aylar dəyişdikdə maaş state-ni yeniləyirik
  useEffect(() => {
    setMonthlySalaries((prev) => {
      const next = { ...prev }
      eligibleMonths.forEach((m) => {
        if (next[m.key] === undefined) {
          next[m.key] = currentGrossSalary || '1000'
        }
      })
      return next
    })
  }, [eligibleMonths])

  // Tarixlər və günlərin sinxronlaşdırılması
  useEffect(() => {
    if (vacationStart && vacationEnd) {
      const res = calculateVacationDaysBetween(vacationStart, vacationEnd)
      if (res) {
        setHolidayInfo(res)
        setVacationDays(res.paidDays)
      }
    }
  }, [vacationStart, vacationEnd])

  const handlePaidDaysChange = (val) => {
    const num = parseInt(val) || 0
    setVacationDays(num)
    if (vacationStart && num > 0) {
      const res = calculateEndDateFromPaidDays(vacationStart, num)
      if (res) {
        setVacationEnd(res.endDateStr)
        setHolidayInfo(res)
      }
    }
  }

  // Bütün aylara eyni maaş tətbiq etmək üçün autofill
  const handleAutofillAllMonths = (amount) => {
    const val = amount !== undefined ? amount : currentGrossSalary
    setMonthlySalaries((prev) => {
      const next = { ...prev }
      eligibleMonths.forEach((m) => {
        next[m.key] = val
      })
      return next
    })
  }

  // 5. Sektor və Vergi Güzəştləri (Calculator 1 standartında)
  const [workplaceType, setWorkplaceType] = useState('main') // 'main' | 'additional'
  const [sector, setSector] = useState('private_non_oil')
  const [tradeUnionRate, setTradeUnionRate] = useState(0)
  const [article102Exemption, setArticle102Exemption] = useState(0)

  // Dropdown states
  const [sectorOpen, setSectorOpen] = useState(false)
  const [exemptionOpen, setExemptionOpen] = useState(false)

  const sectorOptions = [
    {
      value: 'private_non_oil',
      AZ: 'Qeyri-dövlət və qeyri-neft sektoru (Özəl)',
      ENG: 'Private & Non-oil Sector',
      RU: 'Негосударственный и ненефтяной сектор',
      TR: 'Devlet dışı ve petrol dışı sektör (Özel)',
    },
    {
      value: 'state_or_oil',
      AZ: 'Dövlət və neft-qaz sektoru',
      ENG: 'State & Oil-gas Sector',
      RU: 'Государственный и нефтегазовый сектор',
      TR: 'Devlet ve petrol-gaz sektörü',
    },
  ]

  const exemptionOptions = [
    {
      value: 0,
      AZ: 'Güzəşt yoxdur (0 AZN)',
      ENG: 'No exemption (0 AZN)',
      RU: 'Без льготы (0 AZN)',
      TR: 'Muafiyet yok (0 AZN)',
    },
    {
      value: 800,
      AZ: '800 AZN (Şəhid ailə üzvləri - Maddə 102.1-1)',
      ENG: '800 AZN (Martyrs family members - Art. 102.1-1)',
      RU: '800 AZN (Члены семей шехидов - Ст. 102.1-1)',
      TR: '800 AZN (Şehit aile fertleri - Madde 102.1-1)',
    },
    {
      value: 400,
      AZ: '400 AZN (Milli Qəhrəman, Şəhid dul arvadı - Maddə 102.2)',
      ENG: '400 AZN (War heroes, Martyr widows - Art. 102.2)',
      RU: '400 AZN (Герои войны, вдовы шехидов - Ст. 102.2)',
      TR: '400 AZN (Milli Kahraman, Şehit eşi - Madde 102.2)',
    },
    {
      value: 200,
      AZ: '200 AZN (I və II dərəcə əlillər, Müharibə iştirakçıları - Maddə 102.3)',
      ENG: '200 AZN (1st & 2nd degree disabled, Veterans - Art. 102.3)',
      RU: '200 AZN (Инвалиды I и II гр., Ветераны - Ст. 102.3)',
      TR: '200 AZN (I ve II derece engelliler, Gaziler - Madde 102.3)',
    },
    {
      value: 100,
      AZ: '100 AZN (Çernobıl, Məcburi köçkünlər - Maddə 102.4)',
      ENG: '100 AZN (Chernobyl, IDPs - Art. 102.4)',
      RU: '100 AZN (Чернобыльцы, вынужденные переселенцы - Ст. 102.4)',
      TR: '100 AZN (Çernobil, Mecburi göçmenler - Madde 102.4)',
    },
    {
      value: 50,
      AZ: '50 AZN (Himayəsində azı 3 nəfər olanlar - Maddə 102.5)',
      ENG: '50 AZN (At least 3 dependents - Art. 102.5)',
      RU: '50 AZN (Имеющие на иждивении не менее 3 человек - Ст. 102.5)',
      TR: '50 AZN (Bakmakla yükümlü olduğu en az 3 kişi - Madde 102.5)',
    },
  ]

  const steps = [
    {
      title: translate.calculation_type[language] || 'Hesablanma növü',
      text: translate.make_your_choice[language] || 'Seçiminizi edin',
    },
    {
      title: translate.basic_information[language] || 'Əsas məlumat',
      text: translate.enter_info[language] || 'Məlumatlarınızı daxil edin',
    },
    {
      title: translate.result[language] || 'Nəticə',
      text: translate.ready[language] || 'Nəticə hazırdır!',
    },
  ]

  const handleCalculate = () => {
    const salariesArray = eligibleMonths.map((m) => {
      const v = monthlySalaries[m.key]
      return parseFloat(v) || 0
    })

    const result = calculateVacation2026({
      monthlySalaries: salariesArray,
      paidDays: vacationDays,
      currentGrossSalary: parseFloat(currentGrossSalary) || 0,
      currentMonthWorkedPay: parseFloat(currentMonthWorkedPay) || 0,
      sector,
      workplaceType,
      article102Exemption,
      tradeUnionRate,
    })

    // Əlavə tarix və bayram məlumatlarını nəticəyə birləşdiririk
    const fullResult = {
      ...result,
      hireDate,
      vacationStart,
      vacationEnd,
      holidayInfo,
      eligibleMonths: eligibleMonths.map((m) => ({
        label: m.label,
        key: m.key,
        salary: parseFloat(monthlySalaries[m.key]) || 0,
      })),
    }

    sessionStorage.setItem('vacationResult', JSON.stringify(fullResult))
    window.location.href = `/useful/calculator/2/result/${result.averageMonthlyWage}/${result.dailyWage}/${result.paidDays}/${result.grossVacationPay}`
  }

  const selectedSectorLabel =
    sectorOptions.find((s) => s.value === sector)?.[language] || ''
  const selectedExemptionLabel =
    exemptionOptions.find((e) => e.value === article102Exemption)?.[language] || ''

  return (
    <section className={`${styles.container} ${className || ''}`}>
      <Useful search={false} />
      <div className={styles.stepline}>
        <StepLine active={1} data={steps} />
      </div>

      <div className={styles.titleRow}>
        <h2>
          <Calculator />
          {language === 'AZ'
            ? 'Məzuniyyət haqqının hesablanması (2026)'
            : language === 'RU'
            ? 'Расчет отпускных выплат (2026)'
            : language === 'TR'
            ? 'Yıllık İzin Ücreti Hesaplama (2026)'
            : 'Vacation Pay Calculator (2026)'}
        </h2>
      </div>

      {/* İŞ YERİ SEÇİMİ (ƏSAS / ƏLAVƏ) */}
      <div className={styles.modeSwitchRow}>
        <div className={styles.workplaceSwitch}>
          <button
            type="button"
            className={workplaceType === 'main' ? styles.active : ''}
            onClick={() => setWorkplaceType('main')}
          >
            🏢 {language === 'AZ' ? 'Əsas İş Yeri (200 ₼ güzəştlə)' : language === 'RU' ? 'Основное место работы (льгота 200 ₼)' : language === 'TR' ? 'Asıl İş Yeri (200 ₼ muafiyetli)' : 'Main Workplace (200 ₼ exemption)'}
          </button>
          <button
            type="button"
            className={workplaceType === 'additional' ? styles.active : ''}
            onClick={() => setWorkplaceType('additional')}
          >
            💼 {language === 'AZ' ? 'Əlavə İş Yeri' : language === 'RU' ? 'Дополнительное место работы' : language === 'TR' ? 'Ek İş Yeri' : 'Secondary Workplace'}
          </button>
        </div>
      </div>

      {/* 1. TARİXLƏR BLOKU */}
      <div className={styles.sectionCard}>
        <h3 className={styles.sectionSubtitle}>
          📅 {language === 'AZ' ? 'Tarix və Günlər' : language === 'RU' ? 'Даты и дни' : language === 'TR' ? 'Tarihler ve Günler' : 'Dates and Days'}
        </h3>
        <p className={styles.sectionHint}>
          {language === 'AZ'
            ? 'AR Əmək Məcəlləsinin 140-cı maddəsinə əsasən məzuniyyətə çıxılan aydan əvvəlki son 12 tam təqvim ayının qazancı əsas götürülür. Məcəllənin 114-cü maddəsinə əsasən aralığa düşən rəsmi bayram günləri ödənişli günlərə daxil edilmir və işə çıxma tarixini uzadır.'
            : language === 'RU'
            ? 'В соответствии со ст. 140 Трудового кодекса учитывается заработок за последние 12 полных календарных месяцев. По ст. 114 праздничные дни не включаются в оплачиваемые дни отпуска.'
            : language === 'TR'
            ? 'İş Kanunu Madde 140 uyarınca izne çıkılan aydan önceki son 12 tam takvim ayının kazancı esas alınır. Madde 114 uyarınca resmi tatiller ücretli izin günlerine dahil edilmez ve işe dönüş tarihini uzatır.'
            : 'In accordance with Art. 140 of the Labor Code, earnings of previous 12 full calendar months are taken. Art. 114 excludes non-working holidays from paid days.'}
        </p>

        <div className={styles.grid3}>
          <GeneralInput
            id={'hire-date'}
            type={'date'}
            value={hireDate}
            label={
              language === 'AZ'
                ? 'İşə başlama tarixi (əgər 12 aydan azdırsa)'
                : language === 'RU'
                ? 'Дата начала работы (если менее 12 месяцев)'
                : language === 'TR'
                ? 'İşe başlama tarihi (12 aydan az ise)'
                : 'Employment hire date'
            }
            onInput={(e) => setHireDate(e.target.value)}
          />
          <GeneralInput
            id={'vacation-start'}
            type={'date'}
            value={vacationStart}
            label={
              language === 'AZ'
                ? 'Məzuniyyətin başlama tarixi *'
                : language === 'RU'
                ? 'Дата начала отпуска *'
                : language === 'TR'
                ? 'İzin başlangıç tarihi *'
                : 'Vacation start date *'
            }
            onInput={(e) => setVacationStart(e.target.value)}
          />
          <GeneralInput
            id={'vacation-end'}
            type={'date'}
            value={vacationEnd}
            label={
              language === 'AZ'
                ? 'Məzuniyyətin bitmə tarixi *'
                : language === 'RU'
                ? 'Дата окончания отпуска *'
                : language === 'TR'
                ? 'İzin bitiş tarihi *'
                : 'Vacation end date *'
            }
            onInput={(e) => setVacationEnd(e.target.value)}
          />
        </div>

        <div className={styles.grid2} style={{ marginTop: '16px' }}>
          <GeneralInput
            id={'vacation-days'}
            type={'number'}
            value={vacationDays}
            label={
              language === 'AZ'
                ? 'Təyin olunan ödənişli məzuniyyət günü *'
                : language === 'RU'
                ? 'Оплачиваемые дни отпуска *'
                : language === 'TR'
                ? 'Belirlenen ücretli izin günü *'
                : 'Paid vacation days *'
            }
            onInput={(e) => handlePaidDaysChange(e.target.value)}
          />
          <div className={styles.statsCard}>
            <div className={styles.statItem}>
              <span>{language === 'AZ' ? 'Təqvim günü cəmi:' : language === 'RU' ? 'Всего календарных дней:' : language === 'TR' ? 'Toplam takvim günü:' : 'Total calendar days:'}</span>
              <strong>{holidayInfo?.totalCalendarDays || vacationDays} {language === 'AZ' ? 'gün' : language === 'RU' ? 'дней' : language === 'TR' ? 'gün' : 'days'}</strong>
            </div>
            <div className={styles.statItem}>
              <span>{language === 'AZ' ? 'Dövrə düşən bayram günləri:' : language === 'RU' ? 'Праздники в периоде:' : language === 'TR' ? 'Döneme denk gelen tatiller:' : 'Holidays in period:'}</span>
              <strong style={{ color: holidayInfo?.holidaysCount ? '#e53e3e' : '#2d3748' }}>
                {holidayInfo?.holidaysCount || 0} {language === 'AZ' ? 'gün (ödənilmir)' : language === 'RU' ? 'дней (без оплаты)' : language === 'TR' ? 'gün (ücretsiz)' : 'days (unpaid)'}
              </strong>
            </div>
            <div className={styles.statItem}>
              <span>{language === 'AZ' ? 'Faktiki işə qayıtma tarixi:' : language === 'RU' ? 'Дата выхода на работу:' : language === 'TR' ? 'Fiili işe dönüş tarihi:' : 'Actual return to work:'}</span>
              <strong style={{ color: '#0052cc' }}>
                {holidayInfo?.returnDate || '—'}
              </strong>
            </div>
          </div>
        </div>

        {holidayInfo?.holidaysCount > 0 && (
          <div className={styles.holidayAlert}>
            ⚠️ {language === 'AZ'
              ? `Seçilmiş dövrdə ${holidayInfo.holidaysCount} rəsmi bayram/hüzn günü var (${holidayInfo.holidayDates.join(', ')}). AR ƏM Maddə 114-ə əsasən bu günlər məzuniyyətin ödənişli günlərinə daxil edilmir, lakin işçinin işə çıxma tarixini həmin günlər qədər uzadır: ${holidayInfo.returnDate}`
              : language === 'RU'
              ? `В выбранном периоде ${holidayInfo.holidaysCount} праздничных дней. Дата выхода на работу продлевается до ${holidayInfo.returnDate}.`
              : language === 'TR'
              ? `Seçilen dönemde ${holidayInfo.holidaysCount} resmi tatil günü bulunmaktadır (${holidayInfo.holidayDates.join(', ')}). İş Kanunu Madde 114 uyarınca bu günler ücretli izin günlerine dahil edilmez ve işe dönüş tarihini uzatır: ${holidayInfo.returnDate}`
              : `There are ${holidayInfo.holidaysCount} holidays in the period. Return to work is extended to ${holidayInfo.returnDate}.`}
          </div>
        )}
      </div>

      {/* 2. CARİ GROSS VƏZİFƏ MAAŞI VƏ ZƏMANƏT */}
      <div className={styles.sectionCard}>
        <h3 className={styles.sectionSubtitle}>
          💼 {language === 'AZ' ? 'Məcəllə Zəmanəti & Vəzifə Maaşı' : language === 'RU' ? 'Гарантия оклада' : language === 'TR' ? 'Yasal Güvence ve Görev Maaşı' : 'Salary Guarantee'}
        </h3>
        <p className={styles.sectionHint}>
          {language === 'AZ'
            ? 'AR ƏM Maddə 140 və 111-ci maddə təminatı: İşçinin məzuniyyət vaxtı üçün hesablanan orta aylıq əmək haqqı onun məzuniyyətə çıxdığı tarixdə qüvvədə olan Gross vəzifə maaşından az ola bilməz. Əgər 12 ayın ortalaması aşağı edərsə, cari Gross vəzifə maaşı əsas götürülür.'
            : language === 'RU'
            ? 'Ст. 140 и 111: Среднемесячный заработок для отпуска не может быть ниже текущего должностного оклада.'
            : language === 'TR'
            ? 'İş Kanunu Madde 140 ve 111 güvencesi: İzin için hesaplanan ortalama aylık ücret, çalışanın izne çıktığı tarihteki brüt görev maaşından az olamaz. 12 aylık ortalama düşük kalırsa, güncel brüt görev maaşı esas alınır.'
            : 'Art. 140 & 111: Average wage cannot be lower than the current official gross base salary.'}
        </p>

        <div className={styles.grid2}>
          <GeneralInput
            id={'current-gross'}
            type={'number'}
            value={currentGrossSalary}
            label={
              language === 'AZ'
                ? 'Məzuniyyətə çıxdığı aydakı ştat üzrə cari Gross vəzifə maaşı (AZN) *'
                : language === 'RU'
                ? 'Текущий должностной оклад в месяце отпуска (AZN) *'
                : language === 'TR'
                ? 'İzne çıktığı aydaki kadro brüt görev maaşı (AZN) *'
                : 'Current official gross salary in vacation month (AZN) *'
            }
            onInput={(e) => setCurrentGrossSalary(e.target.value)}
          />

          <GeneralInput
            id={'worked-days-pay'}
            type={'number'}
            value={currentMonthWorkedPay}
            label={
              language === 'AZ'
                ? 'Məzuniyyət ayında işlənmiş günlər üçün hesablanan Gross əməkhaqqı (AZN)'
                : language === 'RU'
                ? 'Зарплата за отработанные дни в месяце отпуска (AZN)'
                : language === 'TR'
                ? 'İzin ayında çalışılan günler için brüt maaş (AZN)'
                : 'Gross pay for days worked in the vacation month (AZN)'
            }
            onInput={(e) => setCurrentMonthWorkedPay(e.target.value)}
          />
        </div>
      </div>

      {/* 3. DİNAMİK AYLAR VƏ ƏMƏKHAQQI DAXİLETMƏ QRİDİ */}
      <div className={styles.sectionCard}>
        <div className={styles.headerBetween}>
          <div>
            <h3 className={styles.sectionSubtitle}>
              📊 {language === 'AZ' ? 'Son 12 Tam Təqvim Ayının Qazancları' : language === 'RU' ? 'Заработок за 12 месяцев' : language === 'TR' ? 'Son 12 Tam Takvim Ayının Kazançları' : 'Earnings of Full Months'}
            </h3>
            <p className={styles.sectionHint}>
              {language === 'AZ'
                ? `Nəzərə alınan ${eligibleMonths.length} tam ay təyin olundu (işə başlama və məzuniyyət tarixlərinə uyğun olaraq avtomatik formalaşır).`
                : language === 'RU'
                ? `Определено ${eligibleMonths.length} полных месяцев для расчета.`
                : language === 'TR'
                ? `Dikkate alınan ${eligibleMonths.length} tam ay belirlendi (işe başlama ve izin tarihlerine göre otomatik oluşturulur).`
                : `${eligibleMonths.length} full calendar months eligible.`}
            </p>
          </div>
          <button
            type="button"
            className={styles.autofillBtn}
            onClick={() => handleAutofillAllMonths(currentGrossSalary)}
          >
            ⚡ {language === 'AZ' ? 'Bütün aylara vəzifə maaşını tətbiq et' : language === 'RU' ? 'Применить оклад ко всем месяцам' : language === 'TR' ? 'Tüm aylara görev maaşını uygula' : 'Autofill all months'}
          </button>
        </div>

        <div className={styles.monthsGrid}>
          {eligibleMonths.map((m) => (
            <div key={m.key} className={styles.monthBox}>
              <GeneralInput
                id={`month-${m.key}`}
                type={'number'}
                value={monthlySalaries[m.key] !== undefined ? monthlySalaries[m.key] : ''}
                label={m.label}
                placeholder={'0.00'}
                onInput={(e) => {
                  const val = e.target.value
                  setMonthlySalaries((prev) => ({ ...prev, [m.key]: val }))
                }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* 4. SEKTOR VƏ VERGİ GÜZƏŞTLƏRİ (2026 STANDARTLARI) */}
      <div className={styles.sectionCard}>
        <h3 className={styles.sectionSubtitle}>
          ⚖️ {language === 'AZ' ? 'Vergi və Sektor Parametrləri (2026)' : language === 'RU' ? 'Налоговые параметры (2026)' : language === 'TR' ? 'Vergi ve Sektör Parametreleri (2026)' : 'Tax & Sector Parameters'}
        </h3>
        <div className={styles.grid3}>
          {/* Sektor Dropdown */}
          <div
            className={`${styles.select} ${sectorOpen ? styles.isOpen : ''}`}
            onBlur={() => setTimeout(() => setSectorOpen(false), 250)}
          >
            <p>{language === 'AZ' ? 'Çalışdığınız sektor' : language === 'RU' ? 'Сектор деятельности' : language === 'TR' ? 'Çalıştığınız sektör' : 'Sector'}</p>
            <span
              tabIndex="1"
              title={selectedSectorLabel}
              onClick={() => setSectorOpen(!sectorOpen)}
            >
              <span className={styles.labelValue}>{selectedSectorLabel}</span>
              <LangArrows />
            </span>
            <ul style={{ display: sectorOpen ? 'block' : 'none' }}>
              {sectorOptions.map((opt) => (
                <li
                  key={opt.value}
                  className={sector === opt.value ? styles.isSelected : ''}
                  onClick={() => {
                    setSector(opt.value)
                    setSectorOpen(false)
                  }}
                >
                  {opt[language] || opt.AZ}
                </li>
              ))}
            </ul>
          </div>

          {/* Güzəştlər Dropdown */}
          <div
            className={`${styles.select} ${exemptionOpen ? styles.isOpen : ''}`}
            onBlur={() => setTimeout(() => setExemptionOpen(false), 250)}
          >
            <p>{language === 'AZ' ? 'Güzəştlər (Maddə 102)' : language === 'RU' ? 'Льготы (Ст. 102)' : language === 'TR' ? 'Vergi Muafiyetleri (Madde 102)' : 'Tax Exemptions'}</p>
            <span
              tabIndex="2"
              title={selectedExemptionLabel}
              onClick={() => setExemptionOpen(!exemptionOpen)}
            >
              <span className={styles.labelValue}>{selectedExemptionLabel}</span>
              <LangArrows />
            </span>
            <ul style={{ display: exemptionOpen ? 'block' : 'none' }}>
              {exemptionOptions.map((opt) => (
                <li
                  key={opt.value}
                  className={String(article102Exemption) === String(opt.value) ? styles.isSelected : ''}
                  onClick={() => {
                    setArticle102Exemption(opt.value)
                    setExemptionOpen(false)
                  }}
                >
                  {opt[language] || opt.AZ}
                </li>
              ))}
            </ul>
          </div>

          {/* Həmkarlar İttifaqı */}
          <GeneralInput
            id={'trade-union'}
            type={'number'}
            value={tradeUnionRate}
            label={language === 'AZ' ? 'Həmkarlar İttifaqı (%)' : language === 'RU' ? 'Профсоюзный взнос (%)' : language === 'TR' ? 'Sendika Kesintisi (%)' : 'Trade union (%)'}
            placeholder={'0%'}
            onInput={(e) => setTradeUnionRate(e.target.value)}
          />
        </div>
      </div>

      {/* HESABLA DÜYMƏSİ */}
      <div className={styles.submitWrap}>
        <FormButton
          disabled={vacationDays <= 0}
          onClick={handleCalculate}
        >
          {translate.hesabla[language] || translate.hesabla.AZ || 'HESABLA'}
        </FormButton>
      </div>

      {/* QANUNVERİCİLİK VƏ ALQORİTM MƏLUMAT BLOKU */}
      <div className={styles.legalInfoBox}>
        <h4>
          <Info /> {language === 'AZ' ? 'Hesablanmanın Rəsmi Qanunvericilik Əsasları' : language === 'RU' ? 'Официальная законодательная база' : language === 'TR' ? 'Hesaplamanın Resmi Yasal Dayanağı' : 'Legal Basis'}
        </h4>
        <ul>
          <li>
            <strong>{language === 'AZ' ? 'AR Əmək Məcəlləsi Maddə 140:' : language === 'RU' ? 'Ст. 140 Трудового кодекса:' : language === 'TR' ? 'İş Kanunu Madde 140:' : 'Labor Code Art. 140:'}</strong>{' '}
            {language === 'AZ' ? 'Məzuniyyət vaxtı üçün ödənilən orta əmək haqqı məzuniyyətə çıxılan aydan əvvəlki 12 tam təqvim ayının qazancı əsasında 30.4 əmsalı ilə hesablanır.' :
             language === 'RU' ? 'Среднемесячный заработок для отпуска рассчитывается на основе заработка за последние 12 полных календарных месяцев с коэффициентом 30.4.' :
             language === 'TR' ? 'İzin için ödenen ortalama aylık ücret, izne çıkılan aydan önceki 12 tam takvim ayının kazancı üzerinden 30.4 katsayısı ile hesaplanır.' :
             'Average wage for vacation is calculated on the basis of earnings of 12 full calendar months preceding the vacation month using the 30.4 factor.'}
          </li>
          <li>
            <strong>{language === 'AZ' ? 'Məcəllə Təminatı (Maddə 140 / 111):' : language === 'RU' ? 'Гарантия Кодекса (Ст. 140 / 111):' : language === 'TR' ? 'Kanun Güvencesi (Madde 140 / 111):' : 'Statutory Guarantee (Art. 140 / 111):'}</strong>{' '}
            {language === 'AZ' ? 'Orta aylıq əmək haqqı məzuniyyətə çıxılan aydakı vəzifə maaşından az olarsa, hesablama üçün vəzifə maaşı əsas götürülür.' :
             language === 'RU' ? 'Если средний заработок оказывается ниже текущего оклада, то для расчета принимается оклад.' :
             language === 'TR' ? 'Ortalama aylık kazanç izne çıkılan aydaki görev maaşından az olursa, hesaplamada görev maaşı esas alınır.' :
             'If the 12-month average wage is lower than the current base salary, the base salary is taken as calculation baseline.'}
          </li>
          <li>
            <strong>{language === 'AZ' ? 'AR Əmək Məcəlləsi Maddə 114:' : language === 'RU' ? 'Ст. 114 Трудового кодекса:' : language === 'TR' ? 'İş Kanunu Madde 114:' : 'Labor Code Art. 114:'}</strong>{' '}
            {language === 'AZ' ? 'Məzuniyyət dövrünə təsadüf edən rəsmi iş günü hesab olunmayan bayram günləri məzuniyyətin ödənişli günlərinə daxil edilmir və işə qayıtma tarixini uzadır.' :
             language === 'RU' ? 'Нерабочие праздничные дни, приходящиеся на период отпуска, не включаются в оплачиваемые дни и продлевают отпуск.' :
             language === 'TR' ? 'İzin dönemine denk gelen resmi tatil günleri ücretli izin günlerine dahil edilmez ve işe dönüş tarihini uzatır.' :
             'Non-working holidays falling within the vacation period are not included in paid days and extend the return to work date.'}
          </li>
          <li>
            <strong>{language === 'AZ' ? 'AR Vergi Məcəlləsi Maddə 101, 102 & Sosial Qanunvericilik:' : language === 'RU' ? 'Налоговый кодекс и соцстрахование:' : language === 'TR' ? 'Vergi Kanunu ve Sosyal Güvenlik Mevzuatı:' : 'Tax Code & Social Insurance Legislation:'}</strong>{' '}
            {language === 'AZ' ? 'Hesablanmış cəmi gross məbləğdən (məzuniyyət + işlənmiş günlər) 2026-cı il qanuni tutulmaları çıxılaraq xalis Net ödəniş təyin edilir.' :
             language === 'RU' ? 'Из начисленной суммы (отпускные + отработанные дни) производятся законные удержания для определения чистой выплаты Net.' :
             language === 'TR' ? 'Hesaplanan toplam brüt tutardan (izin ücreti + çalışılan günler) 2026 yılı yasal kesintileri düşülerek net ödeme tutarı belirlenir.' :
             'From the total gross amount (vacation pay + worked days pay), 2026 statutory deductions are subtracted to determine the net take-home pay.'}
          </li>
        </ul>
      </div>
    </section>
  )
}

export default Calculator2
